export default __webpack_public_path__ + "static/media/POD-8.ad7e1ab6.jpg";